import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * On every navigation, scroll to the hash target if there is one (respecting
 * the fixed header via each target's scroll-margin), otherwise scroll to top.
 */
export function ScrollManager() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        // A short delay lets freshly-routed content mount before we measure.
        const t = window.setTimeout(
          () => el.scrollIntoView({ behavior: 'smooth', block: 'start' }),
          60,
        );
        return () => window.clearTimeout(t);
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
  }, [pathname, hash]);

  return null;
}
